// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__16DP5","author":"Table_author__2U3_U","authorImage":"Table_authorImage__39Zvq","unreadRow":"Table_unreadRow__1JeAK"};